import { Event } from "./Event";
/**
 * Item Selecting Event
 */
export class ItemSelectingEvent extends Event {
    /**
     * Constructor
     * @param element element
     * @param data data
     * @param index index
     */
    constructor(element, data, index) {
        super(element, data);
        this.index = index;
    }
    /**
     * Gets index
     */
    getIndex() {
        return this.index;
    }
}
//# sourceMappingURL=ItemSelectingEvent.js.map